import { SxProps, Theme } from '@mui/material';

const BORDER_RADIUS = '8px';

type ListRowBorderSx = {
  index: number;
  total: number;
  borderRadius?: string;
  borderColor?: string;
};

export function getListItemBorderSx({
  index,
  total,
  borderRadius = BORDER_RADIUS,
  borderColor = 'common.light2',
}: ListRowBorderSx): SxProps<Theme> {
  const borderBottom: SxProps<Theme> = {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: borderColor,
  };

  if (total === 1) {
    return { borderRadius: BORDER_RADIUS };
  }
  if (index === 0) {
    return {
      borderRadius: `${BORDER_RADIUS} ${BORDER_RADIUS} 0 0`,
      ...borderBottom,
    };
  }
  if (index === total - 1) {
    return { borderRadius: `0 0 ${borderRadius} ${borderRadius}` };
  }
  return {
    borderRadius: 0,
    ...borderBottom,
  };
}
